// extracted by mini-css-extract-plugin
module.exports = {"navItem":"CrossButton_navItem__QSBha","icon":"CrossButton_icon__cKAoC"};